import axios from "axios";

export const getCountries = async () => {
    try {
        const response = await axios.get(process.env.REACT_APP_SERVICE_PATH_ENV.concat(`/api/countries`), {
          headers: {
            Authorization: `${JSON.parse(sessionStorage.getItem("loggedUser"))?.token
              }`,
          },
        });
      
        return response.data.countries;
      } catch (e) {
        return await {
            "countries": [
              {
                countryCode: "ES",
                countryCommonLabel: "España",
                minLength: 9,
                maxLength: 9
              }
            ]
          }
      }
}

export const getProvinces = async () => {
  try {
    const response = await axios.get(process.env.REACT_APP_SERVICE_PATH_ENV.concat(`/api/countries/ES/provinces`), {
      headers: {
          'Accept-Language': 'ES'
      },
    });
  
    return response.data.provinces;
  } catch (e) {
    return await {
        "provinces": []
      }
  }
}

export const getCountryData = async (code) => {
    try {
        const response = await axios.get(process.env.REACT_APP_SERVICE_PATH_ENV.concat(`/api/countries/` + code), {
          headers: {
            Authorization: `${JSON.parse(sessionStorage.getItem("loggedUser"))?.token
              }`,
          },
        });
      
        return response.data;
      } catch (e) {
        return await {
            "countries": [
              {
                countryCode: "ES",
                countryCommonLabel: "España",
                minLength: 9,
                maxLength: 9
              }
            ]
          }
      }
}